module.exports = __webpack_public_path__ + "b2640e2a96e333bbf6512a0ea5c48e96.png";